import React from "react";
import { connect } from "react-redux";
import FormItem from "components/fields/FormItem";
import { DatePicker, Form, Input } from "antd";
import SelectOption from "components/select/SelectOption";
import { requiredField } from "utils/crudSagaHelper";
import {
    Sparkles,
    UserPlus,
    Briefcase,
    Building2,
    Award,
    FileText,
    Clock,
    Calendar,
    Send,
    ArrowRight,
} from "lucide-react";
import Card from "components/card";
import InputWrapper from "components/fields/InputWrapper";
import TextAreaWrapper from "components/fields/TextAreaWrapper";

const Request = () => {
    const [form] = Form.useForm();

    const onSubmit = (formData) => {
       
    };

    return (
        <Card className="rounded-2xl shadow-lg bg-white border-2 border-stale-200 max-w-[56rem] mx-auto overflow-hidden">
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 border-b rounded-t-2xl p-6">
                <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 backdrop-blur-xl shadow-md p-3 flex-shrink-0">
                        <UserPlus className="w-6 h-6 text-white" />
                    </div>
                    <div>
                        <h4 className="text-[18px] font-semibold text-gray-800">Request New Team Member</h4>
                        <p className="text-[14px] text-gray-600">
                            Submit a hiring request and we'll find the perfect candidate for your team
                        </p>
                    </div>
                </div>
            </div>

            <Form 
                form={form}
                layout="vertical" 
                onFinish={onSubmit} 
            >
                <div className="pb-6 p-8 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <FormItem
                            label="Position Title"
                            icon={Briefcase}
                            rules={[requiredField()]}
                        >
                            <InputWrapper placeholder="e.g., Senior Software Engineer" />
                        </FormItem>
                        <FormItem
                            label="Department *"
                            icon={Building2}
                            rules={[requiredField()]}
                        >
                            <SelectOption
                                placeholder="Select Department"
                                options={[
                                    {label:"Engineering", value: 0},
                                    {label:"Design", value: 1},
                                    {label:"Marketing", value: 2},
                                    {label:"Sales", value: 3},
                                    {label:"Human Resource", value: 4},
                                    {label:"Finance", value: 5},
                                    {label:"Operations", value: 6},
                                ]}
                            />
                        </FormItem>
                        <FormItem
                            label="Urgency Level"
                            icon={Clock}
                        >
                            <SelectOption
                                placeholder="All Stages"
                                options={[
                                    {label:"Low - Flexible Timeline", value: 0},
                                    {label:"Meduim - Within 2-3 Months", value: 1},
                                    {label:"High - Within 1 Month", value: 2},
                                    {label:"Urgent - ASAP", value: 3},
                                ]}
                            />
                        </FormItem>
                        <FormItem
                            label="Preferred Start Date *"
                            icon={Calendar}
                            rules={[requiredField()]}
                        >
                            <div className="bg-gray-50 rounded-lg h-9 flex items-center px-2">
                                <DatePicker 
                                    variant="borderless"
                                    showSearch
                                    style={{
                                        width: "100%",
                                    }}
                                />
                            </div>
                        </FormItem>
                        <div className="md:col-span-2 space-y-6">
                            <FormItem
                                label="Budget Range (Annual)"
                                icon={Award}
                                rules={[requiredField()]}
                            >
                                <InputWrapper 
                                    placeholder="e.g., $80,000 - $120,000 AUD"
                                />
                            </FormItem>
                            <FormItem
                                label="Role Requirements & Responsibilities"
                                icon={FileText}
                                rules={[requiredField()]}
                            >
                                <TextAreaWrapper 
                                    placeholder="Describe the key requirements, responsibilities, and qualifications for this role..." 
                                    rows={5} 
                                />
                                <p className="text-gray-500 text-[12px] sm:text-[13px]">
                                    Include must-have skills, experience level, and any specific qualifications 
                                </p>
                            </FormItem>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 w-full">
                        <div className="p-4 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50 border border-purple-200">
                            <div className="flex items-start gap-3">
                                <Sparkles className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5"/>
                                <div className="text-[13px]">
                                    <h4 className="font-semibold text-purple-900 mb-">What happens next?</h4>
                                    <p className=" text-purple-800 leading-relaxed">
                                        Our recruitment team will review your request within 24 hours and begin sourcing qualified candidates. You'll receive regular updates as candidates progress through the pipeline.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <button className="flex-1 flex items-center justify-center gap-2 rounded-xl px-3 h-12 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white text-sm font-medium shadow-lg hover:shadow-xl transition-all">
                            <Send className="w-4 h-4 mr-2"/>
                            <span>Submit Hiring Request</span>
                            <ArrowRight className="w-4 h-4 ml-2" />
                        </button>

                        <button className="gap-2 border-2 border-gray-300 rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
                            <span>Clear Form</span>
                        </button>
                    </div>
                </div>
            </Form>
        </Card>
    );
};

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(Request);
